/** First prose sentence from a model stream, with tool JSON removed. */
export function firstThinkingLine(raw: string): string {
  const withoutFences = raw.replace(/```[\s\S]*?(```|$)/g, " ");
  const beforeJson = (withoutFences.split(/[{[]/)[0] ?? "")
    .replace(/\s+/g, " ")
    .trim();
  if (!beforeJson) return "";

  const sentence = beforeJson.match(/^([\s\S]*?[.!?])(?:\s|$)/);
  const line = (sentence?.[1] ?? beforeJson).trim();
  return line.slice(0, 140);
}
